import { render, staticRenderFns } from "./paragraph_p.vue?vue&type=template&id=3f7de795&scoped=true&"
import script from "./paragraph_p.vue?vue&type=script&lang=js&"
export * from "./paragraph_p.vue?vue&type=script&lang=js&"
import style0 from "./paragraph_p.vue?vue&type=style&index=0&id=3f7de795&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7de795",
  null
  
)

export default component.exports